'use client';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

import { useNotifyStore } from '@/store/notify';

import style from './fcmModal.module.scss';
import { FcmMessage } from '@/types/notifyCenter';
import FireIcon from './img/fire.svg';
import { getCpInfo } from '@/api/couple/cpInfo';
import BaseButton from '@/components/baseButton/baseButton';
import { useRouter } from 'next/navigation';

interface LiveProps {
    data: FcmMessage;
    handleCloseModal: () => void;
}

function LiveModal({ data, handleCloseModal }: LiveProps) {
    const [account, setAccount] = useState("");
    const [name, setName] = useState("");
    const router = useRouter();

    useEffect(() => {
        async function handleGetCp() {
            if (!data.deep_link.user_id || account || name) return;
            const res = await getCpInfo(data.deep_link.user_id ?? "");
            if (res.status !== 200) return;
            setAccount(res.data.account);
            setName(res.data.nickname);
        }
        handleGetCp();
    }, [data.deep_link, account, name])

    return (<div className={style.liveContainer}>
        <div className={style.title}>
            <FireIcon />
            {data.title}
        </div>
        <div className={style.info}>
            <div className={style.cover}>
                <Image src={data.image} width={40} height={40} alt="WHyWHy user" />
            </div>
            <div className={style.content}>
                {data.content && <div className={style.title}>{name}</div>}
                <div className={style.text}>@{account}</div>
            </div>
            <BaseButton
                type={'normal'}
                className={style.btn}
                onClick={() => {
                    router.push(`/liveStream/viewer/${data.deep_link.live_id}`);
                    handleCloseModal();
                }}
            >
                立即觀看
            </BaseButton>
        </div>
    </div>)
}

function FcmModal() {
    const data = useNotifyStore.use.fcmModalData();
    const closeFcmModal = useNotifyStore.use.closeFcmModal();
    const timeId = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (data.title) {
            if (timeId.current) clearTimeout(timeId.current);
            timeId.current = setTimeout(() => {
                closeFcmModal();
            }, 5000);
        }
    }, [data, closeFcmModal]);

    return (
        <>
            {data.title && (
                <motion.div
                    className={style.fcmModal}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3 }}
                >
                    {data.deep_link.live_id && <LiveModal data={data} handleCloseModal={closeFcmModal} />}
                    {!data.deep_link.live_id && <>
                        <div className={style.cover}>
                            <Image src={data.image} width={48} height={48} alt="WHyWHy user" />
                        </div>
                        <div className={style.content}>
                            <div className={style.title}>{data.title}</div>
                            {data.content && <div className={style.text}>{data.content}</div>}
                        </div>
                    </>}
                </motion.div>
            )}
        </>
    );
}

export default FcmModal;
